import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';
import toast from 'react-hot-toast';

export default function PatientProfile() {
  const { user, updateUser, logout } = useAuthStore();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: user?.name || '', city: user?.city || '',
    gender: user?.gender || 'male', birth_date: user?.birth_date || '',
    preferred_language: user?.preferred_language || 'fr',
  });
  const [pwForm, setPwForm] = useState({ current_password:'', new_password:'' });
  const [loading, setLoading] = useState(false);
  const [pwLoading, setPwLoading] = useState(false);
  const [tab, setTab] = useState('profile');

  const cities = ['Lomé','Kpalimé','Atakpamé','Sokodé','Kara','Dapaong','Tsévié','Aného'];

  const saveProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.put('/patient/profile', form);
      updateUser(res.data.user);
      toast.success('Profil mis à jour !');
    } catch(e) { toast.error('Erreur lors de la mise à jour'); }
    finally { setLoading(false); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    setPwLoading(true);
    try {
      await api.post('/auth/change-password', pwForm);
      toast.success('Mot de passe modifié !');
      setPwForm({ current_password:'', new_password:'' });
    } catch(e) { toast.error(e.response?.data?.message || 'Erreur'); }
    finally { setPwLoading(false); }
  };

  const handleLogout = async () => {
    try { await api.post('/auth/logout'); } catch(e) {}
    logout(); navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-4 py-3 flex items-center gap-3 sticky top-0 z-10">
        <Link to="/patient/dashboard" className="text-green-600 font-medium">← Retour</Link>
        <h1 className="font-bold text-gray-800">Mon profil</h1>
      </div>

      <div className="max-w-lg mx-auto p-4 space-y-4">
        {/* Avatar */}
        <div className="card flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center text-3xl">
            {user?.gender === 'female' ? '👩' : '👤'}
          </div>
          <div>
            <p className="font-bold text-lg text-gray-800">{user?.name}</p>
            <p className="text-sm text-gray-500">📱 {user?.phone}</p>
            <p className="text-sm text-gray-500">📍 {user?.city || 'Non renseigné'}</p>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex gap-2">
          {[['profile','Informations'],['password','Mot de passe']].map(([val,label]) => (
            <button key={val} onClick={() => setTab(val)}
              className={`flex-1 py-2 rounded-xl text-sm font-medium transition-all ${tab===val ? 'bg-green-600 text-white' : 'bg-white text-gray-600 border border-gray-200'}`}>
              {label}
            </button>
          ))}
        </div>

        {tab === 'profile' ? (
          <form onSubmit={saveProfile} className="card space-y-3">
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Nom complet</label>
              <input className="input-field" value={form.name}
                onChange={e => setForm({...form, name: e.target.value})} required />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Ville</label>
              <select className="input-field" value={form.city}
                onChange={e => setForm({...form, city: e.target.value})}>
                <option value="">Sélectionner</option>
                {cities.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Genre</label>
              <select className="input-field" value={form.gender}
                onChange={e => setForm({...form, gender: e.target.value})}>
                <option value="male">Homme</option>
                <option value="female">Femme</option>
                <option value="other">Autre</option>
              </select>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Date de naissance</label>
              <input className="input-field" type="date" value={form.birth_date || ''}
                onChange={e => setForm({...form, birth_date: e.target.value})} />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Langue préférée</label>
              <select className="input-field" value={form.preferred_language}
                onChange={e => setForm({...form, preferred_language: e.target.value})}>
                <option value="fr">Français</option>
                <option value="ewe">Ewé</option>
                <option value="kabye">Kabiyè</option>
              </select>
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full py-3">
              {loading ? 'Enregistrement...' : 'Sauvegarder'}
            </button>
          </form>
        ) : (
          <form onSubmit={changePassword} className="card space-y-3">
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Mot de passe actuel</label>
              <input className="input-field" type="password" value={pwForm.current_password}
                onChange={e => setPwForm({...pwForm, current_password: e.target.value})} required />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">Nouveau mot de passe</label>
              <input className="input-field" type="password" value={pwForm.new_password}
                onChange={e => setPwForm({...pwForm, new_password: e.target.value})} required />
            </div>
            <button type="submit" disabled={pwLoading} className="btn-primary w-full py-3">
              {pwLoading ? 'Modification...' : 'Changer le mot de passe'}
            </button>
          </form>
        )}

        <button onClick={handleLogout}
          className="w-full py-3 text-red-500 border border-red-200 rounded-xl font-medium hover:bg-red-50 transition-all">
          🚪 Se déconnecter
        </button>
      </div>
    </div>
  );
}
